import { ref } from '@vue/composition-api';import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Vue from 'vue';
import { mapGetters } from 'vuex';
import universityCheck from '~/mixins/universityCheck';
import universityBranding from '~/mixins/universityBranding';
import oauthStatusCheck from '~/mixins/oauthStatusCheck';
export default Vue.extend({
  name: 'default',
  mixins: [universityCheck, universityBranding, oauthStatusCheck],
  setup: function setup() {
    var width = ref(0);
    var showSidebar = ref(false);
    return {
      width: width,
      showSidebar: showSidebar
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    isModalOpen: 'getModalOpen'
  })), {}, {
    viewingJobOrBursary: function viewingJobOrBursary() {
      var id = this.$route.params.id;
      var regex = new RegExp("(jobs|bursaries)/".concat(id));
      return regex.test(this.$route.fullPath);
    },
    desktop: function desktop() {
      return this.width > 1280;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.width = window.innerWidth;

    window.onresize = function () {
      _this.width = window.innerWidth;
    };
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    }
  }
});